import { lazy } from 'react';
import * as routes from './routes';
import { ROLES } from "./roleConstants";
import { all } from 'axios';

const ROUTE_SOURCES = [
    {
        
        path: routes.BASE_PATH_PREFIX,
        component: lazy(() => import('../modules/dashboard/view/DashboardRouter')),
        allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.INVESTOR],
    },
    {
        path: routes.LOGIN,
        component: lazy(() => import('../modules/login/view/Login')),
        isPublic: true,
        allowAuthenticated: true,
    },
    {
        path: routes.LOGIN_CALLBACK_PATH,
        component: lazy(() => import('../modules/login/view/LoginCallback')),
        isPublic: true,
        allowAuthenticated: true,
    },
    {
        path: routes.RESET_PASSWORD,
        component: lazy(() => import('../modules/login/view/EmailForgetPasswordPage')),
        isPublic: true,
        allowAuthenticated: true,
    },
    {
        path: routes.DISCLAIMER,
        component: lazy(() => import('../modules/disclaimer/view/Disclaimer')),
        isPublic: true,
        allowAuthenticated: true,
    },
    {
        path: routes.COMMUNICATION,
        component: lazy(() => import('../modules/communication/view/Communication')),
        allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN, ROLES.INVESTOR],
    },
    {
        path: routes.USERS,
        component: lazy(() => import('../modules/user-management/view/Users')),
        allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
    },
    {
        path: routes.USER_DETAILS,
        component: lazy(() => import('../modules/user-management/view/UserDetails')),
        hasParam: true,
        allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
    },
    {
        path: routes.CONTENT_MANAGEMENT,
        component: lazy(() => import('../modules/content-management/view/ContentManagement')),
        allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
    },
    {
        path: routes.CONTENT_MANAGEMENT_DETAILS,
        component: lazy(() => import('../modules/content-management/view/ContentManagementDetails')),
        allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
    },
    {
        path: routes.DATA_CENTER_AUTOMATION,
        component: lazy(() => import('../modules/dataCenterAutomation/view/DataCenterAutomation')),
        hasParam: true,
        allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
    },
    {
        path: routes.DATA_CENTER_AUTOMATION_DETAILS,
        component: lazy(() => import('../modules/dataCenterAutomation/view/DataCenterAutomationDetails')),
        hasParam: true,
        allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
    },
    {
        path: routes.INVESTORS_MANAGEMENT,
        component: lazy(() => import('../modules/investor-management/view/Investors')),
        allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
    },
    {
        path: routes.INVESTORS_MANAGEMENT_DETAILS,
        component: lazy(() => import('../modules/investor-management/view/InvestorDetails')),
        hasParam: true,
        allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
    },
    {
        path: routes.HOLDCO_MANAGEMENT,
        component: lazy(() => import('../modules/holdco/view/HoldCoManagement')),
        allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
    },
    {
        path: routes.DOCUMENT_MASTER,
        component: lazy(() => import('../modules/documentMaster/view/documentMaster')),
        hasParam: true,
        allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
    },
    {
        path: routes.DOCUMENT_MASTER_DETAILS,
        component: lazy(() => import('../modules/documentMaster/view/documentMasterDetails')),
        hasParam: true,
        allowedRoles: [ROLES.ADMIN, ROLES.SUPER_ADMIN],
    },
    {
        path: routes.MY_HOLDINGS,
        component: lazy(() => import('../modules/investor-management/view/MyHoldings')),
        allowedRoles: [ROLES.INVESTOR],
    },
    {
        path: routes.MY_DOCUMENTS,
        component: lazy(() => import('../modules/my-documents/view/Documents')),
        allowedRoles: [ROLES.INVESTOR],
    },
    {
        path: routes.CONTACTUS,
        component: lazy(() => import('../modules/contactUs/view/contactUs')),
        allowedRoles: [ROLES.INVESTOR],
    },
    {
        path: routes.MY_PROFILE,
        component: lazy(() => import('../modules/user-management/view/MyProfile')),
        allowedRoles: [ROLES.INVESTOR],
    }
];

export default ROUTE_SOURCES;

// const oldRoutes = [
//     {
//         path: routes.VESTING_PATH,
//         component: lazy(() => import('../modules/vesting/view/Vesting')),
//     },
//     {
//         path: routes.PORTFOLIO_PATH,
//         component: lazy(() => import('../modules/portfolio/view/Portfolio')),
//     },
//     {
//         path: routes.TRANSACTIONS_PATH,
//         component: lazy(() => import('../modules/transactions/view/Transactions')),
//     },
//     {
//         path: routes.INVESTOR_BULK_UPDATE_DEMO,
//         component: lazy(() => import('../modules/investors/bulkUpdateDemo/view/InvestorBulkUpdateDemo')),
//     },
//     {
//         path: routes.INVESTOR_BULK_UPDATE,
//         component: lazy(() => import('../modules/investors/bulkUpdate/view/InvestorBulkUpdate')),
//     },
//     {
//         path: routes.CONFIGURATION,
//         component: lazy(() => import('../modules/admin/configuration/view/Configuration')),
//     },
//     {
//         path: routes.NOTIFICATIONS,
//         component: lazy(() => import('../modules/admin/notification/view/Notification')),
//     },
//     {
//         path: routes.NOTIFICATION_DETAILS,
//         component: lazy(() => import('../modules/admin/notification/view/NotificationDetails')),
//         hasParam: true,
//     },
//     {
//         path: routes.DATA_UPLOAD_CENTERS,
//         component: lazy(() => import('../modules/admin/dataUploadCenters/view/DataUploadCenters')),
//     },
//     {
//         path: routes.DATA_UPLOAD_CENTER_DETAILS,
//         component: lazy(() => import('../modules/admin/dataUploadCenters/view/DataUploadCenterDetails')),
//         hasParam: true,
//     },
// ]